const initTier = {
  tiers: [],
  tierRewards: [],
  tierId: [],
  filterTenantPage: "",
  isFormLoading: false,
};

export const tierReducer = (state = initTier, action: any) => {
  if (action.type === "SET_TIER") {
    return {
      ...state,
      tiers: action.value,
    };
  }
  if (action.type === "SET_TIER_REWARD") {
    return {
      ...state,
      tierRewards: action.value,
    };
  }
  if (action.type === "SET_TIER_ID") {
    return {
      ...state,
      tierId: action.value,
    };
  }
  if (action.type === "SET_TIER_FILTER_PAGE") {
    return {
      ...state,
      filterTenantPage: action.filterTenantPage,
    };
  }
  if (action.type === "SET_FORM_LOADING") {
    return {
      ...state,
      isFormLoading: action.value,
    };
  }
  return state;
};
